import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllCoupons } from '../../redux/Slices/CouponSlice'
import notify from '../UseNotification';

const UseAdminGetAllCoupons = () => {
    const limit = 4;
    const dispatch = useDispatch()
    const { AllCoupon } = useSelector(state => state.CouponReducer)
    const [pagesCount, setPagesCount] = useState()
    const [SearchValue, setSearchValue] = useState("")
    const [loading, setLoading] = useState(true)
    const [AllCoupons, setAllCoupons] = useState()
    const [Searchloading, setSearchLoading] = useState(true)

    // handle get all coupons
    const getAllCouponsList = async () => {
        setLoading(true)
        await dispatch(getAllCoupons(`limit=${limit}`))
        setLoading(false)
    }

    // to dispatch get all coupons request 
    useEffect(() => {
        getAllCouponsList()
    }, [])

    // handle response of the request
    useEffect(() => {
        if (loading === false) {
            if (AllCoupon && AllCoupon.data) {
                setAllCoupons(AllCoupon)
            }
            if (AllCoupon && AllCoupon.paginationResult) {
                setPagesCount(AllCoupon.paginationResult.numberOfPages)
            }
        }
    }, [loading])

    // handle search input changed
    const ChangeInputSearch = (e) => {
        setSearchValue(e.target.value)
    }

    // handleSearchFunction
    const handleSearchFunction = async () => {
        setSearchLoading(true)
        await dispatch(getAllCoupons(`name=${SearchValue}&limit=${limit}`))
        setSearchLoading(false)
    }

    // handle request response search result
    useEffect(() => {
        if (Searchloading === false) {
            if (AllCoupon && AllCoupon.data) {
                setAllCoupons(AllCoupon)
            }
            if (AllCoupon && AllCoupon.paginationResult) {
                setPagesCount(AllCoupon.paginationResult.numberOfPages)
            }
        }
    }, [Searchloading])

    // handle onpress Pagination function
    const onPress = async (page) => {
        setLoading(true)
        await dispatch(getAllCoupons(`limit=${limit}&page=${page}`))
        setLoading(false)
    }

    // run the handleSearchFunction
    useEffect(() => {
        if (SearchValue === "") {
            getAllCouponsList()
        } else {
            handleSearchFunction()
        }
    }, [SearchValue])



    return [loading, AllCoupons, pagesCount, onPress, SearchValue, ChangeInputSearch]
}

export default UseAdminGetAllCoupons
